import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { PopupContent } from 'shared/ui/poup-content'

import s from './styles.module.scss'

interface Props {
  closeDialog: () => void
}

export const LimitPopup = ({ closeDialog }: Props) => {
  const { t } = useTranslation()
  return (
    <PopupContent
      button={t('okay')}
      title={t('tours_block.limited_tour')}
      content={
        <p className={clsx(s.description, 'regular-14')}>
          {t('tours_block.limited_tour_description')}
        </p>
      }
      onClick={closeDialog}
    />
  )
}
